import React from 'react';
import { Router } from '@reach/router';
import {
  PoiList,
  PoiDetails,
  PoiInformation,
  Routes,
  MPInformation,
  EditStop,
  WaypointDetails,
  Favorites,
  Destinations,
  FastRoute,
  Recents,
  Filter,
  SortBy,
} from '../screens/index';

const Navigation = () => (
  <Router>
    <PoiList path="/" />
    <PoiList path="poiList" />
    <PoiDetails path="destinationInformation" />
    <PoiInformation path="more-information" />
    <MPInformation path="mp-information" />
    <Routes path="routes" />
    <EditStop path="edit-stop" />
    <WaypointDetails path="waypoint-details" />
    <Favorites path="favorites" />
    <Recents path="recents" />
    <Destinations path="destinations" />
    <FastRoute path="fast-route" />
    <Filter path="filter" />
    <SortBy path="sort-by" />
  </Router>
);

export default Navigation;
